import { render, staticRenderFns } from "./BigDataArea.vue?vue&type=template&id=0afa9e0d&"
import script from "./BigDataArea.vue?vue&type=script&lang=js&"
export * from "./BigDataArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports